import { Link } from "react-router-dom";
import type { Star } from "@/mocks/stars";
import Tag from "@/components/base/Tag";

export default function StarCard({ star }: { star: Star }) {
  return (
    <Link
      to={`/stars/${star.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "1 / 1" }}>
        <img
          src={star.avatar}
          alt={`${star.name} 形象照`}
          title={`${star.name} - 朝桐光明星资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent" />
        <span className="absolute bottom-3 left-3 rounded-full bg-accent-500/95 px-2.5 py-0.5 text-xs font-semibold text-foreground-950">
          {star.active}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5 md:p-4">
        <div className="flex items-center justify-between gap-2">
          <h3 className="truncate text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
            {star.name}
          </h3>
          <span className="shrink-0 text-xs text-foreground-500">{star.gender}</span>
        </div>
        <p className="mt-1 text-xs text-foreground-500">
          {star.era} · {star.birth}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {star.tags.slice(0, 2).map((t) => (
            <Tag key={t} tone="muted">
              {t}
            </Tag>
          ))}
        </div>
      </div>
    </Link>
  );
}